'use client'

import React from 'react'

export const FooterDescription = () => {
  return (
    <div className="flex flex-col w-[100%] relative min-h-[100%] ">
      {/* <div
        className="absolute top-[-50px] bg-gradient-to-b h-[50px] w-[100%]"
        style={{
          backgroundImage: 'linear-gradient(180deg, rgba(77, 75, 102, 0.00) 0%, #4D4B66 50.17%)',
        }}
      /> */}
      <img className="w-full h-fit" src="/img/home/loopy/footer_reward.png" />
      <div className="flex flex-col items-start gap-[10px] p-[20px] pb-[40px] self-stretch bg-gray-6 h-[100%]">
        <p className="text-gray-2  text-[16px] font-semibold leading-[20px]">리워드 이벤트 유의사항 안내</p>
        <ul className="text-gray-2  text-[14px] font-normal leading-[22px] list-disc pl-5 space-y-[4px]">
          <li>
            리워드의 페이지 내 이미지는 연출된 예시이며, 실제 리워드는 디자인·사이즈·소재 등이 일부 다를 수 있습니다.
          </li>
          <li>
            모든 리워드는 리워드 신청 기간 종료 후 일괄 제작 및 배송되며, 배송에는 최대 30일 정도 소요될 수 있습니다.{' '}
            {'(*리워드 별로 차이가 있을 수 있습니다.)'}
          </li>
          <li className="text-purple-1">
            리워드 신청 기간은 2025년 11월 10일 까지로, 이 기간이 지나면 추가신청 및 배송지 변경이 불가능하니, 기간 내
            꼭 신청해 주세요.
          </li>
          <li>
            본 이벤트는 당사 사정에 따라 변경될 수 있습니다. 포토카드 세트를 완성하면 지급되는 리워드는, 해당 세트의
            반복 완성 여부와 관계없이 세트별로 최대 1매만 제공됩니다.
          </li>
          <li>
            리워드 신청 시 최초 1회에 한하여 배송비 결제가 필요합니다. 다수의 리워드 신청 시 모든 리워드는 최초 입력하신
            배송지 1곳으로 묶음배송됩니다.
          </li>
          <li>
            리워드 신청은 각 세트별로 '리워드 신청하기'를 통해 신청해주셔야 합니다. 세트를 1종류 이상 완성하셨더라도, 각
            세트별로 리워드를 신청해야 당첨 및 리워드가 제공됩니다.
          </li>
          <li>배송지 수정 및 먹방퀴즈 정답 수정은 {'[설정] - [리워드 신청 내역]'}에서 수정 가능합니다.</li>
          <li>FLO 이용약관 및 운영정책 위반, 또는 부정 참여가 확인될 경우 리워드 지급이 취소될 수 있습니다.</li>
          <li>그 외 리워드 이벤트 관련 문의사항은 고객센터 1599-6034 {'(유료)'}에 문의해 주세요.</li>
        </ul>
      </div>
      <div className="flex flex-col items-start gap-[10px] p-[20px] pb-[40px] self-stretch bg-gray-6 h-[100%]">
        <p className="text-gray-2  text-[16px] font-semibold leading-[20px]">랜덤 디지털 포토카드 구매 유의사항</p>
        <ul className="text-gray-2  text-[14px] font-normal leading-[22px] list-disc pl-5 space-y-[4px]">
          <li>
            랜덤 디지털 포토카드는 구매 이후 구매한 포토카드를 ‘카드 열기’ 또는 보관함을 통하여 포토카드의 내용을
            확인하는 방식으로 사용되는 상품으로 사용 이후 청약철회{'(구매 이후 취소 신청 및 환불)'}가 제한됩니다.
          </li>
          <li>
            청약철회는 이용권 결제일 또는 이용권의 사용 가능일 중 늦은 날로부터 7일 이내 상품 사용내역이 없는 경우,
            고객센터 1599-6034{'(유료)'} 또는 1:1 문의를 통해 청약철회 가능하며 청약철회 시 약관 등에 명시된 환불기준에
            따라 환불됩니다.
          </li>
          <li>
            각 디지털 포토카드는 1회권 또는 10회권 단위로 판매되며, 10회권은 동시에 포토카드 내용 확인이 진행됩니다.
          </li>
          <li>
            랜덤 디지털 포토카드의 특성상 동일한 상품이 중복 지급될 수 있습니다. 이로 인한 교환, 환불은 불가합니다.
          </li>
          <li>
            각 디지털 포토카드의 획득 확률은 고정된 값으로 유지되며, 각 디지털 포토카드 획득 확률은 항상 동일합니다.
          </li>
          <li>
            디지털 포토카드는 서비스 내에서만 감상하실 수 있으며, 다운로드는 제공되지 않습니다. 해당 콘텐츠는 저작권
            보호를 받는 자료로, 무단 복제, 배포, 2차 가공, 상업적 이용은 제한됩니다.
          </li>
          <li>
            디지털 포토카드 서비스는 당사 사정에 따라 종료될 수 있으며, 서비스 종료 시 구매한 디지털 포토카드의 보관에
            대해서는 별도 안내 드릴 예정입니다.
          </li>
          <li>
            본 서비스는 모바일 웹 최적화 서비스로 Chrome 91 이상, Safari 15 이상의 모바일웹을 지원합니다. PC Web 및
            태블릿에서는 정상 작동하지 않을 수 있습니다.
          </li>
          <li>그 외 랜덤 디지털 포토카드 구매 관련 문의사항은 고객센터 1599-6034 {'(유료)'}에 문의해 주세요.</li>
        </ul>
      </div>
      <div className="flex flex-col pt-[24px] pl-[20px] pb-[20px] pr-[20px] bg-white">
        <p className="text-black text-caption1 mb-[8px]">{'(주)'}드림어스컴퍼니</p>
        <a
          href="https://www.music-flo.com/docs/cms/16"
          className="text-gray-3 text-caption1 mb-[2px] flex items-center"
        >
          <span className="text-gray-5 text-caption1 underline">개인정보 처리방침</span>
          <img className="w-[12px] h-[12px]" src="/img/com_arrow_right.svg" />
        </a>
        <p className="text-gray-5 text-caption1 mb-[2px]">
          <span className="text-gray-3 text-caption1 mr-[6px]">대표이사</span>김동훈
        </p>
        <p className="text-gray-5 text-caption1 mb-[2px]">
          <span className="text-gray-3 text-caption1 mr-[6px]">사업자 등록번호</span>214-86-29288
        </p>
        <p className="text-gray-5 text-caption1 mb-[2px]">
          <span className="text-gray-3 text-caption1 mr-[6px]">통신판매업 신고번호</span>2008-서울서초-1039
        </p>
        <p className="text-gray-5 text-caption1 mb-[2px]">
          <span className="text-gray-3 text-caption1 mr-[6px]">주소</span>서울특별시 서초구 강남대로 311 드림플러스 15F
        </p>
        <p className="text-gray-5 text-caption1 mb-[8px]">
          <span className="text-gray-3 text-caption1 mr-[6px]">대표번호</span>1599-6034
        </p>
        <p className="text-gray-3 text-[10px] font-medium leading-[12px] mb-[180px]">© DREAMUS CO., LTD. </p>
      </div>
    </div>
  )
}
